
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';

import { getScheduleAction } from './actions';
import {
    switchDateAction,
    switchTypeAction
} from '../filter/actions';
import { TYPES_VIEW } from '../../constans/types-view';
import { setScheduleInterval } from '../../helpers';
import { Preloader } from '../preloader';
import './style.scss';

const timerSeconds = 30;

class ScheduleByMonth extends React.Component {
    onSelectDay = (date) => {
        const { dispatch, filter } = this.props;
        dispatch(getScheduleAction({ ...filter, date, typeView: TYPES_VIEW[0] }));
        dispatch(switchDateAction(date));
        dispatch(switchTypeAction(TYPES_VIEW[0]));
        setScheduleInterval({ ...filter, date, typeView: TYPES_VIEW[0] }, dispatch);
    }

    filterEmptyWeeks = (schedule) => {
        const isEmptyFirstWeek = schedule[0].days.filter(item => item === null).length === 7;
        const isEmptyLastWeek = schedule[schedule.length - 1].days.filter(item => item === null).length === 7;

        if (isEmptyFirstWeek) {
            schedule.splice(0, 1);
        }
        if (isEmptyLastWeek) {
            schedule.splice(schedule.length - 1, 1);
        }
    }

    render() {
        const { schedule } = this.props;
        const { data: dataSchedule } = schedule;
        const isMobile = window.matchMedia('(max-width: 991px)').matches;

        this.filterEmptyWeeks(dataSchedule);

        const minDate = +moment().set({ hour: 0, minute: 0, second: 0 }).format('X');
        const maxDate = +moment().add(8, 'weeks').set({ hour: 0, minute: 0, second: 0 }).format('X');
        const calendarWidth = isMobile && document.getElementsByClassName('app').length ? document.getElementsByClassName('app')[0].offsetWidth - (30 * 2) : 960;
        const calendarElemHeight = calendarWidth / 7 - 30;

        return (
            <div className="schedule__calendar" style={{ width: !isMobile ? calendarWidth : null }}>
                <div className="schedule__calendar__titles">
                    <div className="schedule__calendar__titles_name">пн</div>
                    <div className="schedule__calendar__titles_name">вт</div>
                    <div className="schedule__calendar__titles_name">ср</div>
                    <div className="schedule__calendar__titles_name">чт</div>
                    <div className="schedule__calendar__titles_name">пт</div>
                    <div className="schedule__calendar__titles_name">сб</div>
                    <div className="schedule__calendar__titles_name">вс</div>
                </div>
                {dataSchedule.map((week, i) => (
                    <div key={`week-${i + 1}`} className="schedule__calendar__week" style={{ height: !isMobile ? calendarElemHeight : null }}>
                        {week.days.map((day, j) => {
                            if (day) {
                                const progress = day.countFreeTickets / day.countTickets * 100;
                                const currentDay = +moment(day.date).set({ hour: 0, minute: 0, second: 0 }).format('X');
                                const isActualDay = currentDay >= minDate && currentDay <= maxDate;

                                if (progress === 0 || day.countTickets === 0) {
                                    return (
                                        <div key={`week-${i + 1}-day-${j + 1}`} className="schedule__calendar__week__day">
                                            <button
                                                type="button"
                                                className="schedule__calendar__week__day__item"
                                                disabled
                                            >
                                                <CircularProgressbar
                                                    value={progress}
                                                    text={moment(day.date).format('D')}
                                                    strokeWidth={6}
                                                    styles={{
                                                        text: {
                                                            fill: '#f1f1f1',
                                                            fontSize: isMobile ? '48px' : '36px',
                                                            dominantBaseline: 'central'
                                                        },
                                                        path: {
                                                            stroke: 'transparent',
                                                            strokeLinecap: 'butt'
                                                        },
                                                        trail: {
                                                            stroke: '#F1F1F1',
                                                            strokeLinecap: 'butt'
                                                        }
                                                    }}
                                                />
                                            </button>
                                        </div>
                                    );
                                }

                                let borderColor;
                                if (progress <= 50 && progress > 25) {
                                    borderColor = '#FFCB00';
                                } else if (progress <= 25) {
                                    borderColor = '#FE3D5F';
                                } else {
                                    borderColor = 'currentColor';
                                }
                                return (
                                    <div key={`week-${i + 1}-day-${j + 1}`} className="schedule__calendar__week__day">
                                        <button
                                            type="button"
                                            className="schedule__calendar__week__day__item"
                                            disabled={!isActualDay}
                                            onClick={() => this.onSelectDay(moment(day.date))}
                                        >
                                            <CircularProgressbar
                                                value={progress}
                                                text={moment(day.date).format('D')}
                                                strokeWidth={6}
                                                styles={{
                                                    text: {
                                                        fill: isActualDay ? '#757575' : '#f1f1f1',
                                                        fontSize: isMobile ? '48px' : '36px',
                                                        dominantBaseline: 'central'
                                                    },
                                                    path: {
                                                        stroke: isActualDay ? borderColor : 'transparent',
                                                        strokeLinecap: 'butt'
                                                    },
                                                    trail: {
                                                        stroke: '#F1F1F1',
                                                        strokeLinecap: 'butt'
                                                    }
                                                }}
                                            />
                                        </button>
                                    </div>
                                );
                            }
                            return <div key={`week-${i + 1}-day-${j + 1}`} className="schedule__calendar__week__day" />;
                        })}
                    </div>
                ))}
            </div>
        );
    }
}

ScheduleByMonth.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter,
    schedule: state.schedule
});

export default connect(mapStateToProps)(ScheduleByMonth);
